var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFooterFixedTelegram = function SvgIconFooterFixedTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M14.307 2.436s1.295-.505 1.186.721c-.035.505-.36 2.273-.611 4.185l-.863 5.663s-.072.83-.72.974c-.647.144-1.619-.505-1.799-.65-.144-.108-2.698-1.731-3.597-2.524-.252-.217-.54-.65.036-1.155l3.777-3.607c.432-.433.863-1.443-.935-.216L5.744 9.253s-.576.361-1.655.037l-2.338-.722s-.864-.541.611-1.082c3.598-1.695 8.023-3.427 11.944-5.05Z"
  })));
};
export default SvgIconFooterFixedTelegram;